<template>
  <main class="">
    <AlertNote class="block laptop:hidden mb-4" v-if="checkNoteAlert()" />
    <div class="flex flex-col laptop:grid grid-cols-1 laptop:grid-cols-3 gap-4 laptop:items-start pb-[20px]">
      <div class="p-3 flex flex-col gap-4 w-full rounded-[20px] shadow-[0px_0px_20px_0px_#00000026] bg-[#fff]">
        <div class="flex items-center justify-between">
          <div class="flex items-center gap-2">
            <span class="w-2 h-2 rounded-full bg-[#FE5000]"></span>
            <span class="w-10 h-2 rounded-full bg-[#FE5000]"></span>
            <h2 class="m-0 font-lato font-[700] text-[20px] text-[#092E87]">Details</h2>
          </div>
          <div v-if="isPartnerQuote && quoteDetail"
            class="mb-0 w-[50px] h-[50px] p-2 flex items-center justify-center rounded-full bg-[#EFEFEF]">
            <img :src="quoteDetail?.partner_info?.company_logo" class="w-full h-full object-contain">
          </div>
        </div>
        <div class="flex items-center justify-between shadow-[0px_0px_20px_0px_#00000026] p-2 rounded-[5px]">
          <h2 class="m-0 font-lato font-medium text-[20px] text-[#092E87]">Quote Status:</h2>
          <div class="py-1 px-3 rounded-[5px] bg-opacity-10 bg-[#FE5000]">
            <p class="m-0 text-[#FE5000]">{{ quoteDetail.status.technician.text }}</p>
          </div>
        </div>
        <ul class="p-0 m-0 flex justify-between laptop:flex-col flex-wrap gap-2 laptop:gap-3 w-full">
          <li class="w-[48%] laptop:w-full">
            <label class="text-[14px] font-lato font-medium leading-[1.5] text-[#999999]">Quote ID:</label>
            <p class="m-0 text-[16px] font-lato font-medium leading-[1] text-[#333333]">
              {{ quoteDetail.id }}
            </p>
          </li>
          <li class="w-[48%] laptop:w-full laptop:hidden">
            <div v-if="isQrEnabled" class="flex items-stretch justify-end cursor-pointer"
              @click="actionButtonClicked('QR Code')">
              <div
                class="p-1.5 !rounded-l-[10px] !rounded-r-[0px] !w-[80px] text-[14px] font-medium border-1 border-[#EFEFEF] bg-[#FFFFFF] text-[#999999]">
                QR Code
              </div>
              <div
                class="flex items-center justify-between w-[35px] h-auto p-1.5 !rounded-r-[10px] !rounded-l-[0px] bg-[#092E87]">
                <img src="../../assets/images/qr-code-white.png" alt="">
              </div>
            </div>
          </li>
          <li v-if="isPartnerQuote" class="w-full">
            <label class="text-[14px] font-lato font-medium leading-[1.5] text-[#999999]">Claim ID:</label>
            <p class="m-0 text-[16px] font-lato font-medium leading-[1] text-[#333333]">
              {{ quoteDetail.partner_info.job_number }}
            </p>
          </li>
          <li class="w-full">
            <label class="text-[14px] font-lato font-medium leading-[1.5] text-[#999999]">Consumer Name:</label>
            <p class="m-0 text-[16px] font-lato font-medium leading-[1] text-[#333333]">
              {{ quoteDetail.consumer.full_name }}
            </p>
          </li>
          <li class="w-full">
            <label class="text-[14px] font-lato font-medium leading-[1.5] text-[#999999]">Phone Number:</label>
            <p class="m-0 text-[16px] font-lato font-medium leading-[1] text-[#333333]">
              <a class="m-0 text-[16px] font-lato font-medium leading-[1] text-[#333333] underline"
                :href="'tel:' + quoteDetail.consumer.phone">
                {{ quoteDetail.consumer.phone }}
              </a>
            </p>
          </li>
          <li class="w-full">
            <label class="text-[14px] font-lato font-medium leading-[1.5] text-[#999999]">Services Type:</label>
            <p class="m-0 text-[16px] font-lato font-medium leading-[1] text-[#333333]">
              {{ quoteDetail.job.title }}
            </p>
          </li>
          <li class="w-full">
            <label class="text-[14px] font-lato font-medium leading-[1.5] text-[#999999]">Source ID:</label>
            <p class="m-0 text-[16px] font-lato font-medium leading-[1] text-[#333333]">
              {{ quoteDetail.job_source.id }}
            </p>
          </li>
          <li class="w-full">
            <label class="text-[14px] font-lato font-medium leading-[1.5] text-[#999999]">Source Type:</label>
            <p class="m-0 text-[16px] font-lato font-medium leading-[1] text-[#333333]">
              {{ quoteDetail.job_source.title }}
            </p>
          </li>
          <li class="w-full">
            <label class="text-[14px] font-lato font-medium leading-[1.5] text-[#999999]">Service:</label>
            <p class="capitalize m-0 text-[16px] font-lato font-medium leading-[1] text-[#333333]">
              {{ quoteDetail?.service_type?.title ?? '' }}
            </p>
          </li>
        </ul>
      </div>
      <div class="col-span-2 flex flex-col gap-4 w-full">
        <AlertNote class="hidden laptop:block" v-if="checkNoteAlert()" />
        <div
          class="mobile:p-1.5 laptop:p-3 flex items-center justify-between mobile:gap-2 laptop:gap-4 w-full mobile:rounded-full laptop:rounded-[20px] shadow-[0px_0px_20px_0px_#00000026] bg-[#fff]">
          <div class="flex items-center mobile:gap-1.5 laptop:gap-3">
            <template v-for="(action, index) in actionButtons.slice(0, buttonShowCount)" :key="index">

              <button v-if="index % 2 == 0" type="button" @click="actionButtonClicked(action.title)"
                class="group flex items-center rounded-full gap-2 p-1.5 pl-3 font-lato font-normal text-[14px] h-[40px] mobile:text-[#fff] laptop:text-[#FE5000] hover:text-[#fff] border-1 border-[#FE5000] mobile:bg-[#FE5000] laptop:bg-[#fff] laptop:hover:bg-[#FE5000] transition duration-300">
                {{action.title }}
                  
                <span v-if="!$helper.isEmpty(getImageSrc(action.image))"
                  class="w-[26px] h-[26px] largeDesktop:h-[30px] largeDesktop:w-[30px] transition duration-300 flex justify-center items-center rounded-full laptop:group-hover:bg-white mobile:bg-white laptop:bg-[#FE5000] relative">
                  <!-- Default Image -->
                  <img :src="getImageSrc(action.image)" alt="icon"
                    class="w-[20px] h-[20px] largeDesktop:w-[22px] largeDesktop:h-[22px] transition mobile:hidden laptop:block laptop:group-hover:hidden" />

                  <!-- Hover Color Version -->
                  <div
                    class="w-[20px] h-[20px] largeDesktop:w-[22px] largeDesktop:h-[22px] absolute transition duration-300 mobile:block laptop:hidden laptop:group-hover:block"
                    :style="{
                      WebkitMask: `url(${getImageSrc(action.image)}) no-repeat center / contain`,
                      mask: `url(${getImageSrc(action.image)}) no-repeat center / contain`,
                      backgroundColor: '#FE5000'
                    }"></div>
                </span>
                <span v-else class="w-[26px] h-[26px] largeDesktop:h-[30px] largeDesktop:w-[30px] transition duration-300 flex justify-center items-center rounded-full relative"></span>
              </button>
              <button v-else type="button" @click="actionButtonClicked(action.title)"
                class="group flex items-center rounded-full gap-2 p-1.5 pl-3 font-lato font-normal text-[14px] h-[40px] mobile:text-[#fff] laptop:text-[#092E87] laptop:hover:text-[#fff] border-1 border-[#092E87] mobile:bg-[#092E87] laptop:bg-[#fff] hover:bg-[#092E87] transition duration-300">
                {{ action.title }}
                <span v-if="!$helper.isEmpty(getImageSrc(action.image))"
                  class="w-[26px] h-[26px] largeDesktop:h-[30px] largeDesktop:w-[30px] transition duration-300 flex justify-center items-center rounded-full laptop:group-hover:bg-white mobile:bg-white laptop:bg-[#092E87] relative">
                  <!-- Default Image -->
                  <img :src="getImageSrc(action.image)" alt="icon"
                    class="w-[20px] h-[20px] largeDesktop:w-[22px] largeDesktop:h-[22px] transition mobile:hidden laptop:block laptop:group-hover:hidden" />

                  <!-- Hover Color Version -->
                  <div
                    class="w-[20px] h-[20px] largeDesktop:w-[22px] largeDesktop:h-[22px] absolute transition duration-300 mobile:block laptop:hidden laptop:group-hover:block"
                    :style="{
                      WebkitMask: `url(${getImageSrc(action.image)}) no-repeat center / contain`,
                      mask: `url(${getImageSrc(action.image)}) no-repeat center / contain`,
                      backgroundColor: '#092E87'
                    }"></div>
                </span>
                <span v-else class="w-[26px] h-[26px] largeDesktop:h-[30px] largeDesktop:w-[30px] transition duration-300 flex justify-center items-center rounded-full relative"></span>


              </button>

            </template>
          </div>
          <div class="flex items-center gap-3">
            <div v-if="isQrEnabled">
              <div class="mobile:hidden laptop:flex items-stretch justify-end cursor-pointer min-w-[120px]"
                @click="actionButtonClicked('QR Code')">
                <div class="p-1.5 !rounded-l-[10px] !rounded-r-[0px] border-1 border-[#EFEFEF] bg-[#FFFFFF]">
                  QR Code
                </div>
                <div
                  class="flex items-center justify-between w-[35px] h-auto p-1.5 !rounded-r-[10px] !rounded-l-[0px] bg-[#092E87]">
                  <img src="../../assets/images/qr-code-white.png" alt="">
                </div>
              </div>
            </div>
            <div v-if="actionButtons.length > buttonShowCount" class="dropdown">
              <button class="w-[35px] h-[35px] rounded-full dropdown-toggle after:!hidden text-[#092E87] bg-[#EFEFEF]"
                type="button" data-bs-toggle="dropdown" aria-expanded="false">
                <i class="fa fa-ellipsis-v" aria-hidden="true"></i>
              </button>

              <ul
                class="dropdown-menu p-2 !border-0 !rounded-[10px] !shadow-[0_0_20px_0_rgba(0,0,0,0.15)] !right-0 !left-auto"
                data-bs-display="dynamic"> <!-- ✅ allow auto flip -->
                <template v-for="(action, index) in actionButtons.slice(buttonShowCount)" :key="'rest-' + index">
                  <li>
                    <a class="dropdown-item !rounded-[5px] hover:!bg-[#FE5000] hover:!text-[#fff] cursor-pointer"
                      @click="actionButtonClicked(action.title)">
                      {{ action.title }}
                    </a>
                  </li>
                </template>
              </ul>
            </div>

          </div>
        </div>
        <div class="p-3 rounded-[20px] shadow-[0px_0px_20px_0px_#00000026] bg-[#fff]">
          <div class="googleApi rounded-[20px] overflow-hidden mt-0">
            <GMapMap :center="center" :zoom="16" map-type-id="terrain" style="width: 100%"
              class="h-[200px] tablet:h-[430px]" :options="{
                zoomControl: false,
                mapTypeControl: false,
                scaleControl: false,
                streetViewControl: false,
                rotateControl: false,
                fullscreenControl: false,
              }">
              <GMapMarker v-for="(m, index) in markers" :key="index" :position="m.position" :clickable="true"
                :draggable="true" @click="center = m.position" />
            </GMapMap>
          </div>
          <div class="laptop:flex justify-between items-center mt-4">
            <p class="text-[14px] text-center laptop:text-left m-0">{{ quoteDetail?.address_text ??
              '' }}</p>
            <div class="!w-max mobile:mx-auto mobile:mt-3 laptop:!m-0 laptop:!flex">
              <button @click="openGoogleMaps()" class="flex items-center gap-2 rounded-full px-3 py-1 bg-[#092E87]">
                <span class="inline-block text-[14px] font-lato text-[#fff]">Directions</span>
                <img src="../../assets/images/diraction-icon.png" alt="" class="w-[25px] h-[25px] object-contain">
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import AlertNote from "@/components/alert_note/AlertNote.vue";
import { mapActions, mapGetters } from "vuex";
import moment from "moment";

export default {
  components: {
    AlertNote
  },
  props: ["actionButtons", "actionButtonClicked", "isQrEnabled"],
  data() {
    return {
      center: {
        lat: 0,
        lng: 0,
      },
      markers: [
        {
          position: {
            lat: 0,
            lng: 0,
          },
        }, // Along list of clusters
      ],
    };
  },
  computed: {
    ...mapGetters(["quoteDetail", "apptDetail"]),

    buttonShowCount() {
      return window.innerWidth <= 768 ? 2 : 3
    },

    isPartnerQuote() {
      return (this.quoteDetail?.partner_info?.id > 0 && this.quoteDetail?.partner_info?.status != '0') || false
    }

  },

  watch: {
    apptDetail: function () {
      // this.markers[0].position.lat = this.apptDetail.lat;
      // this.markers[0].position.lng = this.apptDetail.lng;

      // this.center.lat = this.apptDetail.lat;
      // this.center.lng = this.apptDetail.lng;
    },
  },

  mounted() {
    if (!this.$helper.isEmpty(this.quoteDetail)) {
      this.markers[0].position.lat = this.quoteDetail.address_lat;
      this.markers[0].position.lng = this.quoteDetail.address_lng;

      this.center.lat = this.quoteDetail.address_lat;
      this.center.lng = this.quoteDetail.address_lng;
    } else {
      if (this.quoteDetail != null && this.isPartnerQuote) {
        this.getAppointmentDetailsAPICall({
          id: this.quoteDetail.job_source.id,
        });
      }
    }
  },

  methods: {
    ...mapActions(["getAppointmentDetailsAPICall"]),

    checkNoteAlert() {
      if (this.quoteDetail &&
        this.quoteDetail.partner_info
        && this.quoteDetail.partner_info.show_replacement_opportunity_badge == '1'
        && this.quoteDetail.partner_info.status == '1'
        && this.quoteDetail.partner_info.company_name != 'Vivint'
        && this.quoteDetail.partner_info.replacement_opportunity_number.length > 0) {
        return true
      } else {
        return false
      }
    },
    openGoogleMaps() {
      const desLat = this.quoteDetail.address_lat ?? 0;
      const desLng = this.quoteDetail.address_lng ?? 0;
      const googleMapsUrl = `https://maps.google.com/?q=${desLat},${desLng}`;

      // Check if the Google Maps app is installed
      if (navigator.platform.indexOf("Win") > -1) {
        // Windows platform, open in a new window
        window.open(googleMapsUrl, "_blank");
      } else {
        // Non-Windows platform, try to open in the maps app
        window.location.href = googleMapsUrl;
        //  window.location.href =`geo:0,0?q=${encodeURIComponent(destination)}`;
      }
    },

    getImageSrc(imageName) {
      try {
        return require(`@/assets/images/buttons-icons/${imageName}`);
      } catch (error) {
        return ''; // ya default image
      }
    }
  },
};
</script>
